import React from 'react';
import classNames from 'classnames';
import { useFeatureFlags } from 'components/shared/hooks';
import { TYPES } from 'constants/config';
import { Icon } from 'ui';
import ExternalLink from './ExternalLink';
import RelatedUrlMappingAutoSuggest from './RelatedUrlMappingAutoSuggest';

const EditingMapping = ({
  i18n,
  relatedContentType,
  relatedUrl,
  param,
  addNewExternalLinkMapping,
  unselectedLearningContent,
  addNewMappingFromSuggestion,
  setRelatedContentType,
  cancelEditRelatedUrl,
  learningContent,
}) => {
  const hasChromeExtensionLinkToRelatedUrls = useFeatureFlags([
    'chrome_extension_link_to_external_urls',
  ]);
  const tableCellClasses = classNames('FlexboxTable-cell d-f', {
    'jc-sb': hasChromeExtensionLinkToRelatedUrls,
    'jc-e': !hasChromeExtensionLinkToRelatedUrls,
  });
  const hasResourceExperiment = useFeatureFlags(['resource_experiment']);
  const newMappingPlaceholder = hasResourceExperiment
    ? t('related_urls.new_mapping_placeholder_with_resources')
    : t('related_urls.new_mapping_placeholder_without_resources');

  return (
    <div>
      {relatedContentType === TYPES.EXTERNAL_LINK && (
        <ExternalLink
          i18n={i18n}
          updating={false}
          addNewExternalLinkMapping={addNewExternalLinkMapping}
          setRelatedContentType={setRelatedContentType}
        />
      )}
      {relatedContentType === learningContent && (
        <div className="FlexboxTable-row">
          <div className="FlexboxTable-cell d-f fd-c">
            <RelatedUrlMappingAutoSuggest
              learningContent={unselectedLearningContent}
              addNewMappingFromSuggestion={addNewMappingFromSuggestion}
              i18n={i18n}
              placeholder={newMappingPlaceholder}
            />
          </div>
        </div>
      )}
      <div className="FlexboxTable-row">
        <div className={tableCellClasses}>
          {hasChromeExtensionLinkToRelatedUrls && (
            <div>
              <button
                className="NewButton NewButton--white NewButton--wide mr-12"
                onClick={() => setRelatedContentType(learningContent)}
                type="button"
              >
                <Icon name="add" className="mr-4 c-brand-gray" />
                {i18n.new_learning_content}
              </button>
              <button
                className="NewButton NewButton--white NewButton--wide"
                onClick={() => setRelatedContentType(TYPES.EXTERNAL_LINK)}
                type="button"
              >
                <Icon name="add" className="mr-4 c-brand-gray" />
                {i18n.external_link.new}
              </button>
            </div>
          )}
          <div>
            <button
              className="NewButton NewButton--flat mr-12"
              onClick={cancelEditRelatedUrl}
              type="button"
            >
              {i18n.cancel}
            </button>
            <button
              className="NewButton NewButton--blue NewButton--wide"
              disabled={!relatedUrl[param]}
              type="submit"
            >
              {i18n.save_mapping}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditingMapping;
